module.exports = __webpack_public_path__ + "img/charts.656af2bc.svg";